<template>
    <div class="scroll-top" v-show="isVisible" @click="scrollToTop"></div>
</template>

<script>
export default {
    name: 'Scroll',
    data() {
        return {
            isVisible: false
        }
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },
    methods: {
        scrollToTop() {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
        },
        onScroll() {
            this.isVisible = window.scrollY > screen.height
        }
    },
}
</script>

<style scoped lang="scss">
    .scroll-top {
        position: fixed;
        bottom: 80px;
        right: 20px;
        border: 1px solid black;
        width: 60px;
        height: 60px;
        cursor: pointer;
        caret-color: transparent;
        box-sizing: content-box;
        background: center center / 30% url(/img/icons/arrow-right--black.svg) no-repeat white;
        transform: rotate(270deg);
        z-index: 10;
        &:hover {
            box-shadow: 0 4px 9.3px 0 #00000040;
            border: 2px solid black;
        }
    }
</style>
